<template>
  <formulario-contacto tipo="denuncia" />
</template>

<script>
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto";

export default {
  name: "DenunciarFraude",
  components: {
    FormularioContacto
  }
};
</script>
